import React from "react";
import { Trans } from "@coworker/locales";
import { DetailSection, DetailSectionLeft, SectionTitle } from "./_common";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { SimpleProductInfo } from "@coworker/components/src/components/SimpleProductInfo";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import { ModalContext } from "@coworker/apprestructured/src/layout/context/ModalContextProvider";
import { ModalType } from "@coworker/apprestructured/src/layout/context/modalType";
import { useCombinationArticle } from "@coworker/app/src/components/RoomSettings/hooks/useCombinationArticle";
import {
  useStoreId,
  useCountryId,
} from "@coworker/app/src/core/auth/useLoggedInUser";

function SimpleProductRow({ task }) {
  const navigate = useFixaNavigate();
  const { modalState, toggleModal } = React.useContext(ModalContext);
  const full_id = `${task.product_article_type}${task.product_article_id}`;
  const storeId = useStoreId();
  const userCountryId = useCountryId();

  const { data: basicItem } = useItemInfo(task.product_article_id);

  const shouldFetchCombinationArticle = !basicItem;

  const { data: combinationArticle } = useCombinationArticle(
    storeId,
    userCountryId,
    task.product_article_id,
    {
      enabled: shouldFetchCombinationArticle,
    }
  );
  const item =
    basicItem ??
    (combinationArticle && combinationArticle.length > 0
      ? combinationArticle[0]
      : null);

  return (
    <DetailSection
      data-testid="productSection"
      onClick={() => {
        if (modalState.isTaskDetailSheetOpen && basicItem) {
          toggleModal({ type: ModalType.TaskDetail });
        }
        if (basicItem) {
          navigate(`/product/${full_id}`);
        }
      }}
    >
      <DetailSectionLeft>
        <SectionTitle style={{ userSelect: "none" }}>
          <Trans>product2String</Trans>
        </SectionTitle>
        {item ? (
          <SimpleProductInfo
            title={item?.name}
            description={item?.description}
            formattedNumber={item?.noFormatted}
            withArrow={!!basicItem}
          />
        ) : (
          <p>No product information available</p>
        )}
      </DetailSectionLeft>
    </DetailSection>
  );
}

export default SimpleProductRow;
